import { AgentChatMessage, AgentEventType, AgentRole } from "@coeff/api";

/**
 * Compute which message IDs should be hidden based on EVENT messages in the thread.
 * When a revert EVENT targets message M, M and all messages after M (up to the EVENT)
 * should be hidden from the user.
 */
export function computeRevertedMessageIds(messages: AgentChatMessage[]): Set<string> {
  const revertedIds = new Set<string>();
  const messageOrder = new Map(messages.map((m, i) => [m.id, i]));

  for (const msg of messages) {
    if (msg.role === AgentRole.Event && msg.content.event_type === AgentEventType.Revert) {
      const targetId = msg.content.revert_to_message_id;
      if (targetId && messageOrder.has(targetId)) {
        const targetIndex = messageOrder.get(targetId)!;
        const eventIndex = messageOrder.get(msg.id)!;

        // Hide target message and all messages after it (up to but not including EVENT)
        for (let i = targetIndex; i < eventIndex; i++) {
          revertedIds.add(messages[i].id);
        }
      }
    }
  }

  return revertedIds;
}
